export default __webpack_public_path__ + "static/media/iot posters (1).721018f4.webp";